import React from 'react';
import capabiliaLogo from '../../assets/capabilia-logo.png';

const logoStyleGreen = {
  filter: 'invert(1) sepia(1) saturate(5) hue-rotate(120deg) brightness(0.8)'
};

export const LandingFooter = () => (
  <footer className="border-t border-gray-100 py-10" data-testid="landing-footer">
    <div className="max-w-7xl mx-auto px-6 flex flex-col sm:flex-row items-center justify-between gap-4">
      <div className="flex items-center gap-3">
        <img src={capabiliaLogo} alt="Capabilia" style={{ width: 28, height: 28, ...logoStyleGreen }} />
        <div>
          <p className="font-manrope font-semibold text-sm text-gray-900 leading-none">Persistencia 360</p>
          <p className="text-[11px] text-gray-500">by Capabilia</p>
        </div>
      </div>
      <p className="text-sm text-gray-400">&copy; 2026 Capabilia. Todos los derechos reservados.</p>
    </div>
  </footer>
);
